<template>
	<v-radio v-bind="{ ...baseAttrs, ...$attrs }">
		<template v-for="(_, scopedSlotName) in $slots" #[scopedSlotName]="slotData">
			<slot :name="scopedSlotName" v-bind="slotData"></slot>
		</template>
		<template v-for="(_, slotName) in $slots" #[slotName]>
			<slot :name="slotName"></slot>
		</template>
	</v-radio>
</template>

<script setup>
import { computed, defineOptions } from 'vue'

defineOptions({
	name: 'BaseRadio',
})

const baseAttrs = computed(() => {
	return {
		color: 'black',
	}
})

</script>
